import BaseControlTypeConst from "./BaseControlTypeConst"

export default class ScrollPanelTypeConst extends BaseControlTypeConst {
    static STEP = 'step'


}
